/* Shared cart transport and rendering. Mutations are never automatically retried. */
(function () {
  if (window.CartFlow) return;
  // This deferred script runs after the app's inline defaults. Never create an
  // empty settings object: BCPO uses existingSettings || defaults to initialize.
  if (window.bcpo_settings) window.bcpo_settings.cart_reload = 'off';
  const nativeFetch = window.fetch.bind(window);
  let tail = Promise.resolve();
  let pending = 0;
  let revision = 0;
  let refreshPromise = null;
  let refreshTimer;
  let checkout = false;
  let uncertain = false;
  let displayStale = false;
  let writeFailure = null;
  let knownItems = null;
  let knownCodes = null;   // discount_codes of the last cart this file rendered (Liquid's first render has none)
  const lineIdentities = new Map();
  const lineSignature = item => JSON.stringify([String(item.id), item.selling_plan_allocation?.selling_plan?.id || null,
    Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  function rememberLines(items) {
    (items || []).forEach(item => { if (item.key) lineIdentities.set(item.key, lineSignature(item)); });
  }
  const edits = new Map();

  function url(path) { return (window.Shopify?.routes?.root || '/') + path; }
  // The one parser for VO surcharges stored at the end of a line property: "Blackout | $60", "22\" | $-1".
  // Cart totals (utils.js), the discount box and the cart editor all call this; VO does store negative
  // prices on some small sizes, so the sign is part of the amount. Liquid reads the same suffix with
  // split: ' | $' | last | times: 1 (cart-drawer.liquid / main-cart-items.liquid), which keeps the sign too.
  const PROPERTY_PRICE = /\s\|\s\$(-?[0-9]+(?:\.[0-9]{1,2})?)\s*$/;
  function propertyCents(value) {
    if (typeof value !== 'string') return 0;
    const match = value.match(PROPERTY_PRICE);
    if (!match) return 0;
    const cents = Math.round(Number(match[1]) * 100);
    return Number.isSafeInteger(cents) ? cents : 0;
  }
  // One interaction lock for removal, Undo capture and product-link protection.
  function locked() {
    return pending > 0 || edits.size > 0 || !!refreshTimer || !!refreshPromise || !!recoverDisplay.started
      || checkout || uncertain;
  }
  function notify() {
    document.documentElement.classList.toggle('cart-flow-busy', locked());
    // 结算 CTA 的 loading 必须由 <html> 上的类驱动，不能只靠给按钮加 class：
    // 抽屉每次刷新是整段 innerHTML 替换，Xcotton 随后又会异步重建它那两颗按钮，
    // 任何挂在按钮身上的状态都会在这中间被抹掉，表现就是"样式闪回去又闪回来"。
    // checkout / uncertain 不算重算：前者是终态（按钮另有 loading），后者会一直挂着。
    document.documentElement.classList.toggle('cart-flow-recalculating', (pending > 0 || !!refreshPromise) && !checkout && !uncertain);
    document.querySelectorAll('cart-items input, cart-drawer-items input, cart-note textarea, .coupon input').forEach(input => {
      if (checkout && input.dataset.checkoutDisabled === undefined) {
        input.dataset.checkoutDisabled = String(input.disabled);
        input.disabled = true;
      } else if (!checkout && input.dataset.checkoutDisabled !== undefined) {
        input.disabled = input.dataset.checkoutDisabled === 'true';
        delete input.dataset.checkoutDisabled;
      }
    });
    if (uncertain) recoveryNotice();
    document.dispatchEvent(new CustomEvent('cart:busy'));
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => refresh().catch(e => error(e.message)), 0);
  }
  // These slots are replaced by refresh(): await refresh() BEFORE writing a transient error.
  // Recovery actions that must survive rendering belong outside the cart sections.
  function error(message) {
    const slots = document.querySelectorAll('#cart-errors, #CartDrawer-CartErrors');
    slots.forEach(slot => { slot.textContent = message; slot.style.display = message ? 'block' : ''; });
  }
  function recoveryNotice(message = 'Please reload your cart to confirm the last change before adding again or checking out.') {
    let notice = document.getElementById('cart-recovery-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'cart-recovery-notice';
      notice.setAttribute('role', 'alert');
      Object.assign(notice.style, {position:'fixed',bottom:'16px',left:'16px',right:'16px',zIndex:'2147483647',background:'#fff',color:'#111',padding:'20px',border:'1px solid #555',boxShadow:'0 2px 16px #0003'});
      const text = document.createElement('p');
      text.textContent = message;
      const link = document.createElement('a');
      link.href = url('cart');
      link.textContent = 'Reload and review cart';
      link.style.textDecoration = 'underline';
      const dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.textContent = 'Dismiss';
      dismiss.style.marginLeft = '16px';
      dismiss.addEventListener('click', () => {
        text.hidden = true;
        dismiss.hidden = true;
        notice.removeAttribute('role');
        notice.style.left = 'auto';
        notice.style.padding = '8px 12px';
        link.focus();
      });
      notice.append(text, link, dismiss);
      document.body.append(notice);
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      link.focus();
    }
  }
  function recoverDisplay(openRequested = false) {
    const visible = document.getElementById('main-cart-items') || document.querySelector('cart-drawer.active');
    if (!visible && !openRequested) return;
    const marker = 'cart-display-recovery';
    try {
      const previous = Number(sessionStorage.getItem(marker) || 0);
      if (Date.now() - previous < 30000) {
        if (openRequested && !recoverDisplay.started) {
          recoverDisplay.started = true;
          notify();
          window.location.assign(url('cart'));
        }
        return;
      }
      sessionStorage.setItem(marker, String(Date.now()));
    } catch (_) { /* Storage may be unavailable; this document still only recovers once. */ }
    if (recoverDisplay.started) return;
    recoverDisplay.started = true;
    notify();
    if (visible) window.location.reload();
    else window.location.assign(url('cart'));
  }
  function reviewAdded() { recoverDisplay(true); }
  function updateCount(cart) {
    if (!cart || !Number.isFinite(cart.item_count)) return;
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    let badge = icon.querySelector('.cart-count-bubble');
    if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count-bubble'; icon.append(badge); }
    const visibleCount = document.createElement('span');
    visibleCount.setAttribute('aria-hidden', 'true');
    visibleCount.textContent = '(' + cart.item_count + ')';
    visibleCount.hidden = cart.item_count >= 100;
    const accessibleCount = document.createElement('span');
    accessibleCount.className = 'visually-hidden';
    accessibleCount.textContent = cart.item_count + ' items';
    badge.replaceChildren(visibleCount, accessibleCount);
    badge.removeAttribute('aria-label');
    badge.hidden = false;
  }
  async function transport(input, config = {}, read = 'response', timeout = 15000) {
    const controller = new AbortController();
    const abort = () => controller.abort();
    const external = config.signal;
    if (external?.aborted) abort();
    external?.addEventListener('abort', abort, { once: true });
    let timer;
    try {
      return await Promise.race([
        (async () => {
          const headers = new Headers(config.headers || {});
          if (!headers.has('Accept')) headers.set('Accept', 'application/json');
          let response;
          try {
            response = await nativeFetch(input, { ...config, headers, signal: controller.signal });
          } catch (cause) {
            // Browser-specific fetch errors are not useful instructions for shoppers.
            if (cause?.name === 'AbortError') throw cause;
            throw new Error('We could not reach the store. Please check your connection and try again.');
          }
          if (read === 'response') {
            // Keep the queue locked until the response body has actually arrived.
            await response.clone().arrayBuffer();
            const clone = response.clone();
            let validJson = true;
            if (typeof clone.json === 'function') {
              try { await clone.json(); } catch (_) { validJson = false; }
            }
            if (!validJson || response.headers?.get('content-type')?.includes('text/html')) {
              throw new Error('The store could not confirm your cart change. Please reload and review your cart before trying again.');
            }
            return response;
          }
          let body;
          try { body = read === 'json' ? await response.json() : await response.text(); }
          catch (cause) {
            throw new Error(response.status === 429
              ? 'The store is busy. Please wait a moment and try viewing your cart again.'
              : 'Your cart could not be loaded. Please try viewing your cart again.');
          }
          if (!response.ok) {
            const failure = new Error(body?.description || body?.message || 'Unable to update your cart. Please try again.');
            failure.status = response.status;
            throw failure;
          }
          return body;
        })(),
        new Promise((_, reject) => {
          timer = setTimeout(() => { abort(); reject(new Error('The request timed out. Please check your cart before trying again.')); }, timeout);
        })
      ]);
    } finally {
      clearTimeout(timer);
      external?.removeEventListener('abort', abort);
    }
  }
  function defer(key, action) {
    const old = edits.get(key);
    if (old) clearTimeout(old.timer);
    const entry = { action, timer: setTimeout(() => flush().catch(e => error(e.message)), 300) };
    edits.set(key, entry);
    notify();
  }
  async function flush() {
    const actions = [...edits.values()];
    edits.clear();
    const tasks = actions.map(entry => { clearTimeout(entry.timer); return entry.action(); });
    try { await Promise.all(tasks); }
    catch (e) { writeFailure = e; throw e; }
  }
  async function idle() {
    do { await flush(); const current = tail; await current; if (current === tail && !edits.size) break; } while (true);
  }
  async function prepareMutation(config, operation) {
    const isSample = item => (item.handle || '').includes('swatches') || (item.url || '').includes('swatches');
    let data;
    if (config.body instanceof FormData) data = Object.fromEntries(config.body.entries());
    else if (typeof config.body === 'string') {
      try { data = JSON.parse(config.body); } catch (_) { return; }
    }
    if (!data) return;
    const samples = new Set([...document.querySelectorAll('.swatchList .item[data-id], .popupList .popupBox[data-id], .popupList [data-swatch-tile][data-id]')].map(el => el.dataset.id));
    if (typeof product !== 'undefined' && product.tags?.includes('Swatches Sample')) {
      product.variants?.forEach(variant => samples.add(String(variant.id)));
    }
    if (typeof cartData !== 'undefined') cartData.items?.filter(isSample).forEach(item => samples.add(String(item.id)));
    const requested = (data.items || [data]).filter(item => samples.has(String(item.id)));
    if (operation === 'add' && !requested.length) return;
    if (operation === 'update' && !data.updates) return;
    const current = await transport(url('cart.js'), {cache: 'no-store'}, 'json');
    if (operation === 'change' && data.id !== undefined) {
      const requestedId = String(data.id);
      let candidates = current.items.filter(item => item.key === requestedId);
      if (!candidates.length) {
        const identity = lineIdentities.get(requestedId);
        candidates = identity ? current.items.filter(item => lineSignature(item) === identity)
          : current.items.filter(item => String(item.id) === requestedId);
      }
      // Never choose the first of multiple customizations of the same variant.
      if (candidates.length !== 1) {
        return new Response(JSON.stringify({status: 409, description: 'Your cart has changed. Please review the updated items before changing this quantity.'}),
          {status: 409, headers: {'Content-Type': 'application/json'}});
      }
      data.id = candidates[0].key;
      delete data.line;
      if (config.body instanceof FormData) {
        const body = new FormData();
        for (const [key, value] of config.body.entries()) if (key !== 'id' && key !== 'line') body.append(key, value);
        body.set('id', data.id);
        config.body = body;
      } else config.body = JSON.stringify(data);
    }
    rememberLines(current.items);
    const count = current.items.filter(isSample).reduce((total, item) => total + item.quantity, 0);
    let next = count;
    if (operation === 'add') next += requested.reduce((total, item) => total + Number(item.quantity ?? 1), 0);
    else if (operation === 'change') {
      const line = data.line ? current.items[Number(data.line) - 1] : current.items.find(item => item.key === String(data.id) || String(item.id) === String(data.id));
      if (line && isSample(line) && data.quantity !== undefined) next += Number(data.quantity) - line.quantity;
    } else if (operation === 'update') {
      current.items.forEach((item, index) => {
        const quantity = Array.isArray(data.updates) ? data.updates[index] : data.updates[item.key] ?? data.updates[item.id];
        if (isSample(item) && quantity !== undefined) next += Number(quantity) - item.quantity;
      });
    }
    // Existing over-limit carts must still be able to decrease quantities or remove items.
    if (next > 10 && next > count) {
      return new Response(JSON.stringify({status: 422, description: 'You can add up to 10 free swatches.'}), {status: 422, headers: {'Content-Type':'application/json'}});
    }
  }

  // Xcotton prices its checkout button from the cart it sees; the discount-shape mismatch that broke that is
  // patched on Xcotton's own extension hook in layout/theme.liquid (before content_for_header), not here.

  // A write issued from inside an enqueue()d task (see below). It goes out through window.fetch so outer
  // wrappers (Xcotton) see it, and this wrapper recognises it by exact path + body and runs it at once:
  // it already holds the queue, so queueing it again would wait on itself forever.
  let innerRequest = null;

  // Also covers existing fetch-based app integrations; XHR apps remain external.
  window.fetch = function (input, config = {}) {
    const address = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
    const method = (config.method || input?.method || 'GET').toUpperCase();
    if (address.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js)?$/.test(address.pathname) || method !== 'POST') {
      return nativeFetch(input, config);
    }
    if (innerRequest && innerRequest.path === address.pathname && config.body === innerRequest.body) {
      const own = innerRequest;
      innerRequest = null;
      own.seen();
      return transport(input, config);
    }
    if (recoverDisplay.started) return Promise.reject(new Error('Opening your updated cart…'));
    if (checkout || uncertain) return Promise.reject(new Error('Please wait for checkout or reload your cart before making another change.'));
    config = {...config};
    if (typeof cartData !== 'undefined') rememberLines(cartData.items);
    rememberLines(knownItems);
    pending++;
    revision++;
    notify();
    const operation = tail.then(async () => {
      if (uncertain) throw new Error('Please reload your cart to confirm the previous change.');
      if (/\/cart\/(add|change|update)/.test(address.pathname)) {
        const operation = address.pathname.match(/\/cart\/(add|change|update)/)[1];
        const rejected = await prepareMutation(config, operation);
        if (rejected) return rejected;
      }
      try {
        const result = await transport(input, config);
        writeFailure = result.ok ? null : new Error('A cart change was rejected. Please review your cart before checking out.');
        return result;
      } catch (e) { uncertain = true; e.message = 'We could not confirm the last change. Please reload and review your cart before trying again.'; throw e; }
    });
    tail = operation.then(() => {}, () => {});
    return operation.finally(() => {
      pending--;
      scheduleRefresh();
      notify();
    });
  };

  // A read-then-write cart change (e.g. discount codes: read the current codes, write the new set,
  // maybe roll back) queued as ONE mutation. Checkout's idle() waits on tail, so it waits for the
  // whole operation instead of locking the cart between the read and the write. Inside the task use
  // the given read/mutate helpers, never window.fetch directly (that would queue behind itself).
  // mutate() still goes out through window.fetch so outer app wrappers observe the write (Xcotton
  // reprices its checkout button from cart mutations it sees); see innerRequest above.
  function enqueue(task) {
    if (recoverDisplay.started) return Promise.reject(new Error('Opening your updated cart…'));
    if (checkout || uncertain) return Promise.reject(new Error('Please wait for checkout or reload your cart before making another change.'));
    pending++;
    revision++;
    notify();
    const read = (input, config = {}) => transport(input, config, 'json');
    const mutate = async (input, body) => {
      const payload = JSON.stringify(body);
      let reachedUs = false;
      let timer;
      innerRequest = { path: new URL(String(input), location.href).pathname, body: payload, seen: () => { reachedUs = true; } };
      // If an outer wrapper swallows or rewrites the request it never reaches us, and we cannot know
      // whether it will still be sent later: stop and ask for a reload rather than guess.
      const guard = new Promise((_, reject) => {
        timer = setTimeout(() => { if (!reachedUs) reject(Object.assign(new Error('lost'), { lost: true })); }, 3000);
      });
      let response;
      try {
        response = await Promise.race([
          window.fetch(input, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: payload }),
          guard
        ]);
      } catch (e) {
        // An HTTP error is a confirmed rejection (handled below); anything else means we don't know what was written.
        uncertain = true;
        e.message = 'We could not confirm the last change. Please reload and review your cart before trying again.';
        throw e;
      } finally {
        clearTimeout(timer);
        innerRequest = null;
      }
      let data;
      try { data = await response.json(); }
      catch (_) {
        uncertain = true;
        throw new Error('We could not confirm the last change. Please reload and review your cart before trying again.');
      }
      if (!response.ok) {
        const failure = new Error(data?.description || data?.message || 'Unable to update your cart. Please try again.');
        failure.status = response.status;
        throw failure;
      }
      return data;
    };
    const operation = tail.then(() => {
      if (uncertain) throw new Error('Please reload your cart to confirm the previous change.');
      return task({ read, mutate });
    }).catch(e => {
      // tail swallows this rejection, so a checkout waiting in idle() would never see it. Record it
      // where createDraftOrder() looks (same contract as a rejected fetch mutation above): the
      // shopper tried to change the cart and it failed, so this checkout must stop and say so.
      writeFailure = new Error('A cart change was rejected. Please review your cart before checking out.');
      throw e;
    });
    tail = operation.then(() => {}, () => {});
    return operation.finally(() => {
      pending--;
      scheduleRefresh();
      notify();
    });
  }

  function specs() {
    const parts = [];
    if (document.querySelector('cart-drawer')) parts.push({ section: 'cart-drawer', selector: '#CartDrawer' });
    const page = document.getElementById('main-cart-items');
    if (page) {
      const section = page.dataset.id;
      parts.push({ section, selector: '#main-cart-items' });
      for (const selector of ['#main-cart-footer', '#main-cart-shipping']) {
        if (document.querySelector(selector)) parts.push({ section, selector });
      }
    }
    if (document.getElementById('cart-icon-bubble')) parts.push({ section: 'cart-icon-bubble', selector: '#cart-icon-bubble', fallback: '.shopify-section' });
    return parts;
  }
  // Reconcile cart-page markup in place so unchanged images and inputs do not flash.
  function patchChildren(target, source) {
    let cursor = target.firstChild;
    const identity = node => node.nodeType === 1 ? node.getAttribute('data-key') || node.id || '' : '';
    const compatible = (a, b) => a && a.nodeType === b.nodeType && a.nodeName === b.nodeName && identity(a) === identity(b);
    for (const desired of [...source.childNodes]) {
      let node = cursor;
      if (!compatible(node, desired)) {
        node = identity(desired) ? [...target.childNodes].find(child => compatible(child, desired)) : null;
        if (node) target.insertBefore(node, cursor);
        else { node = desired.cloneNode(true); target.insertBefore(node, cursor); cursor = node.nextSibling; continue; }
      }
      if (node.nodeType === 1) {
        const dirtyValue = node === document.activeElement && 'value' in node && node.value !== node.defaultValue && !node.dataset.pending ? node.value : null;
        for (const attr of [...node.attributes]) if (!desired.hasAttribute(attr.name) && attr.name !== 'data-pending') node.removeAttribute(attr.name);
        for (const attr of [...desired.attributes]) if (node.getAttribute(attr.name) !== attr.value) node.setAttribute(attr.name, attr.value);
        patchChildren(node, desired);
        if ('value' in node && 'value' in desired) node.value = dirtyValue ?? desired.value;
      } else if (node.nodeValue !== desired.nodeValue) node.nodeValue = desired.nodeValue;
      cursor = node.nextSibling;
    }
    while (cursor) { const next = cursor.nextSibling; cursor.remove(); cursor = next; }
  }
  // The drawer is replaced wholesale, so its scroll position is restored against
  // the line that sat at the top of the list. Removing a line must not jump the
  // shopper back to the first item.
  function captureScroll(target, survives) {
    // A closed drawer keeps its old scrollTop, but whatever opens it next decides
    // what should be in view: restoring here would hide a freshly added line.
    if (!target.closest('cart-drawer')?.classList.contains('active')) return [];
    return [...target.querySelectorAll('cart-drawer-items, .drawer__inner')]
      .filter(element => element.scrollTop > 0)
      .map(element => {
        const selector = element.matches('cart-drawer-items') ? 'cart-drawer-items' : '.drawer__inner';
        const edge = element.getBoundingClientRect().top;
        const rows = [...element.querySelectorAll('.cart-item[data-key]')];
        const index = rows.findIndex(row => row.getBoundingClientRect().bottom > edge);
        const state = { target, selector, key: null, offset: 0, scrollTop: element.scrollTop };
        if (index < 0) return state;
        if (survives(rows[index].dataset.key)) {
          state.key = rows[index].dataset.key;
          state.offset = rows[index].getBoundingClientRect().top - edge;
        } else {
          // The anchor row is the one being removed: let the next survivor fill its place.
          state.key = rows.slice(index + 1).find(row => survives(row.dataset.key))?.dataset.key || null;
        }
        return state;
      });
  }
  function restoreScroll(states) {
    const anchored = [];
    states.forEach(state => {
      const element = state.target.querySelector(state.selector);
      if (!element) return;
      const row = state.key && [...element.querySelectorAll('.cart-item[data-key]')].find(item => item.dataset.key === state.key);
      // Browsers clamp an over-long offset, so a shorter list simply lands at its end.
      if (!row) { element.scrollTop = state.scrollTop; return; }
      element.scrollTop += row.getBoundingClientRect().top - element.getBoundingClientRect().top - state.offset;
      anchored.push(row);
    });
    return anchored;
  }
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = null;
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      let failures = 0;
      let latestCart = null;
      while (true) {
        try {
        await idle();
        const version = revision;
        const parts = specs();
        const names = [...new Set(parts.map(p => p.section))];
        const [cart, sections] = await Promise.all([
          transport(url('cart.js'), { cache: 'no-store' }, 'json').then(cart => { latestCart = cart; return cart; }),
          names.length ? transport(url('cart') + '?sections=' + names.map(encodeURIComponent).join(','), { cache: 'no-store', headers: {Accept: '*/*'} }, 'json') : {}
        ]);
        if (version !== revision || pending || edits.size) continue;
        if (!Array.isArray(cart.items)) throw new Error('Unable to read your cart. Please reload the page.');
        const oldItems = knownItems || (typeof cartData !== 'undefined' ? cartData.items : []) || [];
        const signature = lineSignature;
        rememberLines(oldItems);
        const keyChanges = new Map();
        // Liquid sections can retain a pre-discount key while cart.js returns a new key.
        const reconcileKeys = source => {
          source.querySelectorAll('.cart-item[data-key]').forEach(row => {
            if (cart.items.some(item => item.key === row.dataset.key)) return;
            const identity = lineIdentities.get(row.dataset.key);
            const candidates = identity ? cart.items.filter(item => signature(item) === identity)
              : cart.items.filter(item => String(item.id) === row.dataset.itemId);
            if (candidates.length !== 1) throw new Error('Your cart changed. Please reload and review your items.');
            lineIdentities.set(row.dataset.key, signature(candidates[0]));
            keyChanges.set(row.dataset.key, candidates[0].key);
            row.dataset.key = candidates[0].key;
          });
        };
        // Validate every section before applying any of them.
        const replacements = parts.map(part => {
          if (typeof sections[part.section] !== 'string') throw new Error('Your cart changed, but could not be displayed. Please reload the page.');
          const doc = new DOMParser().parseFromString(sections[part.section], 'text/html');
          const source = doc.querySelector(part.selector) || (part.fallback && doc.querySelector(part.fallback));
          const target = document.querySelector(part.selector);
          if (!source || !target) throw new Error('Unable to display your cart. Please reload the page.');
          reconcileKeys(source);
          return { source, target };
        });
        // A current section key also needs to be mapped onto the old DOM row.
        // Otherwise patchChildren treats a discount-key change as a new product.
        document.querySelectorAll('.cart-item[data-key]').forEach(row => {
          if (cart.items.some(item => item.key === row.dataset.key)) return;
          const identity = lineIdentities.get(row.dataset.key);
          if (!identity) return;
          const matches = cart.items.filter(item => signature(item) === identity);
          if (matches.length === 1) keyChanges.set(row.dataset.key, matches[0].key);
        });
        const focus = document.activeElement;
        const focusKey = focus?.closest('.cart-item')?.dataset.key;
        const focusName = focus?.name;
        document.querySelectorAll('.cart-item[data-key]').forEach(row => {
          if (keyChanges.has(row.dataset.key)) row.dataset.key = keyChanges.get(row.dataset.key);
        });
        // Per-line UI state keyed by line key (e.g. expanded details) must follow the same mapping.
        if (keyChanges.size) document.dispatchEvent(new CustomEvent('cart:keys', { detail: new Map(keyChanges) }));
        const survives = key => cart.items.some(item => item.key === key);
        const scrollStates = replacements.flatMap(({target}) =>
          target.id.startsWith('main-cart-') ? [] : captureScroll(target, survives));
        replacements.forEach(({source, target}) => {
          if (target.id.startsWith('main-cart-')) patchChildren(target, source);
          else target.innerHTML = source.innerHTML;
          target.classList.toggle('is-empty', source.classList.contains('is-empty'));
        });
        // The container survives innerHTML replacement; its highlighted rows do not.
        document.querySelectorAll('.notification.notification-open').forEach(notification => {
          if (!notification.querySelector('.cart-item.active')) notification.classList.remove('notification-open');
        });
        document.querySelectorAll('cart-drawer, cart-items').forEach(el => el.classList.toggle('is-empty', cart.item_count === 0));
        knownItems = JSON.parse(JSON.stringify(cart.items));
        knownCodes = JSON.stringify(cart.discount_codes || []);
        if (typeof applyCartData === 'function') applyCartData(cart);
        const anchors = restoreScroll(scrollStates);
        if (focusKey && !document.contains(focus)) {
          const row = [...document.querySelectorAll('.cart-item')].find(el => el.dataset.key === focusKey && el.closest('cart-drawer')?.classList.contains('active'))
            || [...document.querySelectorAll('#main-cart-items .cart-item')].find(el => el.dataset.key === focusKey);
          const control = row && [...row.querySelectorAll('[name]')].find(el => el.name === focusName);
          control?.focus();
        }
        const drawer = document.querySelector('cart-drawer.active');
        if (drawer && focus?.closest('cart-drawer') && !document.contains(focus) && typeof trapFocus === 'function') {
          const container = drawer.querySelector('#CartDrawer');
          // Focus follows the list, not the header: restoreScroll has just put the
          // anchor line in view, while a short drawer can scroll its header away.
          const nearby = anchors.find(row => container.contains(row))?.querySelector('button, a, input');
          trapFocus(container, document.contains(document.activeElement) && container.contains(document.activeElement) ? document.activeElement : (nearby || container.querySelector('button, a, input')));
        }
        displayStale = false;
        document.dispatchEvent(new CustomEvent('cart:rendered', { detail: cart }));
        ownRenderDone();
        return cart;
        } catch (failure) {
          if (uncertain) throw failure;
          if (++failures < 2) continue; // Retry reads/rendering only, never the mutation.
          displayStale = true;
          updateCount(latestCart);
          recoverDisplay();
          return latestCart;
        }
      }
    })().finally(() => { refreshPromise = null; notify(); });
    notify();
    return refreshPromise;
  }
  // Apps change the cart behind our back and redraw parts of it themselves. Xcotton, on the way back from
  // checkout, removes its shipping-protection line through its own channel and then swaps the drawer's
  // .totals with freshly rendered section HTML (its "update.fn.default" refresh) — no cart:rendered, so
  // utils.js never refills Subtotal / discount rows and cartData still holds the removed line
  // (2026-09-24 review: the -$100 row vanished, Total included protection).
  //
  // Two signals, both from DOM mutations we did not make (2026-09-25 review):
  //   - summary broken: after every render we remember the Subtotal / discount list / Total nodes we filled and
  //     whether each had text. A node an app swapped in (not ours), or one of ours emptied in place (Xcotton
  //     does both), is repaired with a refresh — even if the cart data is identical. This check is DOM-only.
  //     Text edits that keep the text (currency app wrapping prices in spans) don't count, so no loop.
  //   - cart lines redrawn: read /cart.js once; re-render if lines or codes differ from what we rendered.
  // Our own mutations are dropped exactly (takeRecords at the end of each render), not by a time window,
  // and a check that lands while we are busy is retried afterwards instead of dropped.
  // /cart renders its discount rows in .discounts__wrapper > ul.discounts (only when a code applies).
  const SUMMARY = ['#CartDrawer .subtotalPrice', '#CartDrawer .cart_Total', '#CartDrawer .totals ul.discounts',
    '#main-cart-footer .subtotalPrice', '#main-cart-footer .cart_Total', '#main-cart-footer .totals ul.discounts'].join(', ');
  const STRUCTURE = '.cart-item, .subtotalPrice, .cart_Total, .totals, ul.discounts, .discounts__wrapper, .cart-drawer__footer';
  const ownSummary = new WeakMap(); // node -> had text when we rendered it
  let renderedSummary = [];         // the nodes of our last render: one that is gone (deleted outright) is broken too
  let surfaceObserver = null;
  let externalTimer = null;
  let externalCheckRunning = false;
  let structureChanged = false;  // cart rows added/removed by someone else -> compare with /cart.js
  let summaryTouched = false;    // something changed in or around the summary -> DOM integrity check
  const cartShape = (items, codes) => (items || []).map(item => item.key + ':' + item.quantity).join('|')
    + (codes === null ? '' : '#' + codes);
  const hasText = node => node.textContent.trim() !== '';
  const summaryBroken = () => renderedSummary.some(node => !node.isConnected)
    || [...document.querySelectorAll(SUMMARY)].some(node => !ownSummary.has(node) || (ownSummary.get(node) && !hasText(node)));
  function rememberSummary() {
    renderedSummary = [...document.querySelectorAll(SUMMARY)];
    renderedSummary.forEach(node => ownSummary.set(node, hasText(node)));
  }
  function ownRenderDone() {
    rememberSummary();
    surfaceObserver?.takeRecords();
  }
  const isElement = node => node.nodeType === 1;
  const touchesRows = node => isElement(node) && (node.matches('.cart-item') || !!node.querySelector('.cart-item'));
  const touchesSummary = node => isElement(node) && (node.matches(STRUCTURE) || !!node.querySelector(STRUCTURE));
  function onSurfaceMutations(records) {
    for (const record of records) {
      const nodes = [...record.addedNodes, ...record.removedNodes];
      if (nodes.some(touchesRows)) structureChanged = true;
      if (nodes.some(touchesSummary) || (isElement(record.target) && record.target.closest(SUMMARY))) summaryTouched = true;
    }
    if (structureChanged || summaryTouched) scheduleExternalCheck();
  }
  function scheduleExternalCheck() {
    if (checkout || uncertain || recoverDisplay.started) return;
    clearTimeout(externalTimer);
    externalTimer = setTimeout(runExternalCheck, 400);
  }
  async function runExternalCheck() {
    if (checkout || uncertain || recoverDisplay.started) return;
    // Busy with our own write or render: look again once it is done — never drop the signal.
    if (pending || edits.size || refreshPromise || externalCheckRunning) { scheduleExternalCheck(); return; }
    if (!structureChanged && !summaryTouched) return;
    const linesMayDiffer = structureChanged;
    structureChanged = false;
    summaryTouched = false;
    externalCheckRunning = true;
    try {
      let stale = summaryBroken();
      if (!stale && linesMayDiffer) {
        const cart = await transport(url('cart.js'), { cache: 'no-store' }, 'json');
        const baseItems = knownItems || (typeof cartData !== 'undefined' ? cartData.items : []);
        stale = cartShape(baseItems, knownCodes)
          !== cartShape(cart.items, knownCodes === null ? null : JSON.stringify(cart.discount_codes || []));
      }
      if (stale) {
        if (pending || edits.size || refreshPromise || checkout) { structureChanged = linesMayDiffer; summaryTouched = true; scheduleExternalCheck(); }
        else refresh().catch(e => error(e.message));
      }
    } catch (_) { /* a failed read is not evidence of a change */ }
    finally { externalCheckRunning = false; }
  }
  function watchCartSurfaces() {
    if (typeof MutationObserver !== 'function') return;
    surfaceObserver = new MutationObserver(onSurfaceMutations);
    const watched = new Set();
    const attach = () => document.querySelectorAll('cart-drawer, #main-cart-items, #main-cart-footer').forEach(el => {
      if (watched.has(el)) return;
      watched.add(el);
      surfaceObserver.observe(el, { childList: true, subtree: true });
    });
    attach();
    // utils.js has already filled the first render (deferred scripts run before DOMContentLoaded)
    rememberSummary();
    document.addEventListener('cart:rendered', attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCartSurfaces);
  else watchCartSurfaces();

  // Back/forward from the HTTP cache (2026-10-05 QA: removed a line on /cart, went back to the PDP, the drawer
  // still had the removed line, 4 items and the old total until a reload). A bfcache restore (event.persisted)
  // is already handled by layout/theme.liquid's pageshow listener (cart fingerprint vs cartData -> reload) and
  // bcpo.js (/products reload), so it is left to them. What nobody handled: Chrome reusing the cached HTML for
  // a back navigation — no persisted, a fresh JS run, but the Liquid drawer and cartData come from that old
  // response. Compare once with /cart.js; re-render only on a difference.
  // Checkout keeps its own lock until navigation (price.js) — never touch the cart around it.
  async function reconcileOnReturn() {
    if (checkout || uncertain || recoverDisplay.started) return;
    try {
      await idle();
      if (checkout || uncertain || refreshPromise) return;
      const cart = await transport(url('cart.js'), { cache: 'no-store' }, 'json');
      if (!Array.isArray(cart.items)) return;
      const baseItems = knownItems || (typeof cartData !== 'undefined' ? cartData.items : []) || [];
      const stale = cartShape(baseItems, knownCodes)
        !== cartShape(cart.items, knownCodes === null ? null : JSON.stringify(cart.discount_codes || []));
      if (stale) await refresh();
    } catch (_) { /* a failed read is not evidence of a change */ }
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted) return;
    const navigation = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (navigation?.type === 'back_forward') reconcileOnReturn();
  });

  window.CartFlow = {
    url, refresh, idle, defer, enqueue, error, reviewAdded, recoverDisplay, propertyCents,
    blockForReview(message) { uncertain = true; recoveryNotice(message); notify(); },
    checkoutRecovery: () => recoveryNotice('We could not confirm your checkout. Reload and review your cart before trying again.'),
    get displayStale() { return displayStale; },
    get recoveringDisplay() { return !!recoverDisplay.started; },
    readMutation: async response => {
      try { return await response.json(); }
      catch (cause) {
        uncertain = true;
        notify();
        throw new Error('The store could not confirm your cart change. Please reload and review your cart before trying again.');
      }
    },
    json: (input, config, timeout) => transport(input, config, 'json', timeout),
    get busy() { return pending > 0 || edits.size > 0 || !!refreshTimer || !!refreshPromise || !!recoverDisplay.started; },
    get locked() { return locked(); },
    get uncertain() { return uncertain; },
    get checkout() { return checkout; },
    get writeFailure() { return writeFailure; },
    acknowledgeFailure() { writeFailure = null; },
    setCheckout(value) { checkout = value; notify(); }
  };
  document.addEventListener('click', async event => {
    const remove = event.target.closest('.coupon .couponList [data-coupon] .close');
    const button = event.target.closest('.coupon button');
    const shortcut = event.target.closest('.coupon h2 span');
    if (shortcut) {
      const area = shortcut.closest('.coupon');
      area.querySelector('input').value = shortcut.textContent;
      area.querySelector('button')?.click();
      return;
    }
    if (!button && !remove) return;
    event.preventDefault();
    const area = (button || remove).closest('.coupon');
    if (area.dataset.busy || checkout || uncertain) return;
    const code = (remove ? remove.closest('[data-coupon]').dataset.coupon : area.querySelector('input')?.value || '').trim();
    if (!code) { area.querySelector('input')?.focus(); return; }
    area.dataset.busy = 'true';
    if (button) button.disabled = true;
    try {
      await idle();
      const cart = await transport(url('cart.js'), {}, 'json');
      let codes = (cart.discount_codes || []).map(item => item.code);
      codes = codes.filter(item => item.toLowerCase() !== code.toLowerCase());
      if (!remove) codes.push(code);
      const response = await fetch(url('cart/update.js'), {
        method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: codes.join(',')})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to apply this discount.');
      await refresh();
      if (!remove && !(data.discount_codes || []).some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable)) {
        error('This discount is not applicable to your cart.');
      }
    } catch (e) { error(e.message); }
    finally { delete area.dataset.busy; if (button) button.disabled = false; }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('.coupon input')) {
      event.preventDefault(); event.target.closest('.coupon').querySelector('button')?.click();
    }
  });
  let visualizedBusy = false;
  window.addVisualizedToCart = async function (item) {
    if (visualizedBusy || checkout || uncertain || recoverDisplay.started) return false;
    const host = document.getElementById('visualized-tool-app');
    let slot = host?.querySelector('[data-cart-error]');
    if (!slot && host) {
      slot = document.createElement('p'); slot.dataset.cartError = ''; slot.setAttribute('role', 'alert'); host.prepend(slot);
    }
    if (slot) slot.textContent = '';
    visualizedBusy = true;
    let added = false;
    try {
      if (!item.id || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Please select an available product and a valid quantity.');
      const response = await fetch(url('cart/add.js'), {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(item)});
      const data = await response.json();
      added = response.ok && !data.status;
      await refresh();
      if (!added) throw new Error(data.description || data.message || 'This item could not be added.');
      const drawer = document.querySelector('cart-drawer');
      if (drawer) await drawer.renderContents(data, {refreshed: true});
      else window.location.assign(url('cart'));
      return true;
    } catch (e) {
      const message = added ? 'This item was added. Please open your cart to review it before adding again.' : e.message;
      if (slot) slot.textContent = message; else error(message);
      if (added) reviewAdded();
      return false;
    } finally { visualizedBusy = false; }
  };
})();
